module.exports = __webpack_public_path__ + "img/shopx4.1ddb6147.png";